/* Bagimliliksiz hero slider denetleyicisi.
   v2.6.1: klavye (ok/Home/End), tam ARIA tab semantigi, section:unload
   temizligi (zamanlayici sizintisi), block:select, prefers-reduced-motion,
   odakla duraklatma ve tema editorunde calisan oklar. */
(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var registry = new WeakMap();

  function initSlider(root) {
    if (!root || root.dataset.nativeSliderReady === 'true') return;

    var slides = Array.prototype.slice.call(root.querySelectorAll(':scope > .native-slider__slide'));
    if (!slides.length) return;

    var parent = root.parentElement;
    var nav = parent && parent.querySelector('[data-native-slider-nav]');
    var tabs = nav ? Array.prototype.slice.call(nav.querySelectorAll('[data-native-slide-to]')) : [];
    var controls = parent && parent.querySelector('[data-native-slider-controls]');

    root.dataset.nativeSliderReady = 'true';

    var uid = root.id || 'native-slider-' + Math.abs(hashString(root.outerHTML.slice(0, 200)));
    var index = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true' && !prefersReducedMotion;
    var speed = Math.max(1200, parseInt(root.dataset.autoplaySpeed || '6000', 10));

    // --- ARIA iskeleti -------------------------------------------------
    if (nav) {
      nav.setAttribute('role', 'tablist');
      if (!nav.getAttribute('aria-label')) nav.setAttribute('aria-label', 'Slides');
    }

    slides.forEach(function (slide, i) {
      if (!slide.id) slide.id = uid + '-panel-' + i;
      slide.setAttribute('role', tabs.length ? 'tabpanel' : 'group');
      slide.setAttribute('aria-roledescription', 'slide');
      if (tabs[i]) {
        if (!tabs[i].id) tabs[i].id = uid + '-tab-' + i;
        slide.setAttribute('aria-labelledby', tabs[i].id);
        tabs[i].setAttribute('aria-controls', slide.id);
      }
      slide.dataset.nativeSlideIndex = i;
    });

    // --- Oklar (tema editorunde de calisir) ------------------------------
    if (controls && !controls.querySelector('.prev-arrow')) {
      controls.innerHTML =
        '<button type="button" class="prev-arrow native-slider-arrow" aria-label="Previous slide"></button>' +
        '<button type="button" class="next-arrow native-slider-arrow" aria-label="Next slide"></button>';
    }

    function show(next, userInitiated) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.hidden = i !== index;
      });
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      if (userInitiated) restart();
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function restart() {
      stop();
      if (autoplay && slides.length > 1) {
        timer = window.setInterval(function () {
          show(index + 1, false);
        }, speed);
      }
    }

    function focusTab(i) {
      if (!tabs[i]) return;
      show(i, true);
      tabs[i].focus();
    }

    if (controls) {
      var prev = controls.querySelector('.prev-arrow');
      var next = controls.querySelector('.next-arrow');
      if (prev) prev.addEventListener('click', function () { show(index - 1, true); });
      if (next) next.addEventListener('click', function () { show(index + 1, true); });
    }

    tabs.forEach(function (tab, i) {
      tab.setAttribute('role', 'tab');
      tab.addEventListener('click', function () { show(i, true); });
      tab.addEventListener('keydown', function (event) {
        switch (event.key) {
          case 'Enter':
          case ' ':
          case 'Spacebar':
            event.preventDefault();
            show(i, true);
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            event.preventDefault();
            focusTab((i + 1) % tabs.length);
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            event.preventDefault();
            focusTab((i - 1 + tabs.length) % tabs.length);
            break;
          case 'Home':
            event.preventDefault();
            focusTab(0);
            break;
          case 'End':
            event.preventDefault();
            focusTab(tabs.length - 1);
            break;
          default:
            break;
        }
      });
    });

    // Fare VE klavye ile duraklatma (WCAG 2.2.2)
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', restart);
    if (parent) {
      parent.addEventListener('focusin', stop);
      parent.addEventListener('focusout', function (event) {
        if (!parent.contains(event.relatedTarget)) restart();
      });
    }

    registry.set(root, {
      stop: stop,
      show: show,
      teardown: function () {
        stop();
        root.dataset.nativeSliderReady = 'false';
      }
    });

    show(0, false);
    restart();
  }

  function hashString(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) {
      h = (h << 5) - h + str.charCodeAt(i);
      h |= 0;
    }
    return h;
  }

  function eachSlider(scope, fn) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-native-slider]')) fn(scope);
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-native-slider]'), fn);
    }
  }

  function initAll(scope) {
    eachSlider(scope || document, initSlider);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

  // v2.6.1: bunun olmamasi, editorde her duzenlemede bir setInterval siziyordu
  document.addEventListener('shopify:section:unload', function (event) {
    eachSlider(event.target, function (root) {
      var api = registry.get(root);
      if (api) api.teardown();
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('.native-slider__slide');
    if (!slide) return;
    var root = slide.parentElement;
    var api = registry.get(root);
    if (!api) return;
    api.stop();
    api.show(parseInt(slide.dataset.nativeSlideIndex || '0', 10), false);
  });
})();
